import React from "react";
import { Form, Icon, Input, Button } from "antd";
import "./style.scss";
import Axios from "axios";
import logo from "../../kombu2.png";
import Background from "./backgroundkombu1.jpg";

import { baseUrl } from "../../config";
const NormalLoginForm = (props) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      if (!err) {
      }
      Axios.post(baseUrl + "user/login", {
        email: values.email,
        password: values.password,
      }).then((response) => {
        if (response.data.user.admin === false) {
          window.localStorage.setItem("token", response.data.user.token);
          props.changeToken();
          props.history.push("/users/list");
        }
      });
    });
  };

  const { getFieldDecorator } = props.form;
  return (
    <div
      style={{
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        height: "100vh",
        width: "100%",
        flexDirection: "column",
        backgroundImage: `url(${Background})`,
        padding: 300,
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          padding: 30,
          borderStyle: "solid",
          borderWidth: 2,
          borderRadius: 10,
          borderColor: "#1d1d1d",
          height: "400px",
          width: "500px",
          alignItems: "center",
          position: "relative",
          margin: "0 auto",
          display: "flex",
          justifyContent: "flex-start",
          backgroundColor: "#1d1d1d",
          opacity: "0.9",
          flexDirection: "column",
        }}
      >
        <img
          style={{ marginBottom: 20, width: "300px" }}
          src={logo}
          alt="internetonfurniture.com"
        />

        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator("email", {
              rules: [{ required: true, message: "Please input your email!" }],
            })(
              <Input
                prefix={
                  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Email"
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: "Please input your Password!" },
              ],
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="Password"
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

const WrappedNormalLoginForm = Form.create({ name: "normal_login" })(
  NormalLoginForm
);

export default WrappedNormalLoginForm;
